(() => {
  const CARD_SELECTOR = '[data-kp-story-card]';
  const PLAY_SELECTOR = '[data-kp-story-play]';

  const loadVideoSource = (video) => {
    if (!video || video.dataset.loaded === 'true') return;

    const sources = video.querySelectorAll('source[data-src]');
    if (sources.length > 0) {
      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
    } else if (video.dataset.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      video.load();
    }
    video.dataset.loaded = 'true';
  };

  const pauseOtherVideos = (currentVideo) => {
    document
      .querySelectorAll(`${CARD_SELECTOR} .kp-story-video`)
      .forEach((v) => {
        if (v !== currentVideo && !v.paused) {
          if (!v.muted) {
            v.muted = true;
            v.closest(CARD_SELECTOR)?.classList.remove('is-unmuted');
          }
        }
      });
  };

  const setupStoryCard = (card) => {
    if (!card || card.dataset.storyBound === 'true') return;
    card.dataset.storyBound = 'true';

    const video = card.querySelector('.kp-story-video');
    const playBtn = card.querySelector(PLAY_SELECTOR);

    if (!video) return;

    // Ensure video is initially muted for browser autoplay compliance
    video.muted = true;
    video.playsInline = true;

    video.addEventListener('play', () => {
      card.classList.add('is-playing');
      card.classList.toggle('is-unmuted', !video.muted);
      if (playBtn) {
        playBtn.setAttribute(
          'aria-label',
          video.muted ? 'Unmute video audio' : 'Mute video audio'
        );
      }
    });

    video.addEventListener('pause', () => {
      card.classList.remove('is-playing');
      if (playBtn) {
        playBtn.setAttribute('aria-label', 'Play video');
      }
    });

    video.addEventListener('volumechange', () => {
      card.classList.toggle('is-unmuted', !video.muted);
      if (playBtn) {
        playBtn.setAttribute(
          'aria-label',
          video.muted ? 'Unmute video audio' : 'Mute video audio'
        );
      }
    });

    // Handle card and button click interactions
    card.addEventListener('click', (event) => {
      // Allow link navigation if user clicks a link inside card
      if (event.target.closest('a')) return;

      const isPlayBtnClick = Boolean(event.target.closest(PLAY_SELECTOR));
      loadVideoSource(video);

      if (isPlayBtnClick) {
        // Clicking top-right action button
        if (video.paused) {
          video.play().catch(() => {});
        } else if (video.muted) {
          // Unmute video with audio on user click
          pauseOtherVideos(video);
          video.muted = false;
        } else {
          // Mute again
          video.muted = true;
        }
      } else {
        // Clicking the card body toggles play / pause
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });
  };

  // IntersectionObserver for lazy loading and in-view autoplay
  const initStoryObservers = () => {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    cards.forEach(setupStoryCard);

    if ('IntersectionObserver' in window) {
      const storyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const card = entry.target;
            const video = card.querySelector('.kp-story-video');
            if (!video) return;

            if (entry.isIntersecting) {
              // 1. Lazy load video stream on demand (0 bytes downloaded before reaching)
              loadVideoSource(video);

              // 2. Auto-play on mute when entering viewport
              if (
                video.hasAttribute('data-autoplay-in-view') ||
                video.dataset.autoplayInView !== undefined
              ) {
                video.muted = true;
                const playPromise = video.play();
                if (playPromise !== undefined) {
                  playPromise.catch(() => {
                    // Browser policy fallback
                  });
                }
              }
            } else {
              // 3. Pause when scrolled out of view to save mobile CPU/battery
              if (!video.paused) {
                video.pause();
              }
            }
          });
        },
        { rootMargin: '120px 0px', threshold: 0.25 }
      );

      cards.forEach((card) => storyObserver.observe(card));
    } else {
      // Fallback for browsers without IntersectionObserver
      cards.forEach((card) => {
        const video = card.querySelector('.kp-story-video');
        if (video) loadVideoSource(video);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryObservers);
  } else {
    initStoryObservers();
  }

  document.addEventListener('shopify:section:load', initStoryObservers);

  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      .querySelectorAll?.(`${CARD_SELECTOR} .kp-story-video`)
      .forEach((video) => {
        video.pause();
        video.closest(CARD_SELECTOR)?.classList.remove('is-playing');
      });
  });
})();